<template>
  <div
    class="flex-y-center flex-col justify-between w-full pb-4 md:px-4 md:pb-4 border-b md:border-b-0 md:border-r border-gray-250 md:max-w-[300px]"
  >
    <div class="flex items-start w-full border-b border-gray-200 pb-2 gap-2">
      <img src="/images/svg/bot-pack.svg" alt="Pack" />
      <div class="flex flex-col items-start">
        <p class="text-sm text-gray">{{ $t("plan_text") }}</p>
        <p class="text-lg leading-normal font-medium text-dark-100">
          {{ plan }}
        </p>
      </div>
    </div>
    <div class="w-full grid grid-cols-2 gap-3 mt-3">
      <FGroup
        :label="$t('commission')"
        label-class="text-xs text-gray"
        class="!gap-1"
      >
        <span class="text-sm text-green text-left">
          {{ commissionPercent }}%
        </span>
      </FGroup>
      <FGroup
        :label="$t('strategies')"
        label-class="text-xs text-gray"
        class="!gap-1"
      >
        <div class="flex-y-center gap-1 flex-wrap">
          <div
            class="inline-flex items-center text-xs"
            v-for="(info, idx) of strategies"
            :key="idx"
          >
            <span>{{
              info?.base_strategy_name ? info?.base_strategy_name : info?.title
            }}</span>
            <div
              class="w-1 h-1 bg-dark/40 rounded-xl ml-1"
              v-if="idx !== strategies?.length - 1"
            />
          </div>
        </div>
      </FGroup>
      <FGroup
        :label="$t('currency')"
        label-class="text-xs text-gray"
        class="!gap-1"
      >
        <span class="text-sm text-left">USDT</span>
      </FGroup>
      <FGroup
        :label="$t('coins')"
        label-class="text-xs text-gray"
        class="!gap-1"
      >
        <div class="flex-y-center relative coin-wrapper">
          <template v-for="(coin, i) of coins?.list" :key="i">
            <div
              v-html="coin?.image_svg"
              class="coin-image shrink-0 w-[26px] h-[26px] z-10 border border-gray-200 rounded-full"
              :style="`z-index: ${i + 10}; `"
            />
          </template>
          <span class="text-xs ml-1" v-if="coins?.element > 0"
            >+{{ coins?.element }}</span
          >
        </div>
      </FGroup>
    </div>
  </div>
</template>

<script setup lang="ts">
import FGroup from "@/components/Form/FGroup.vue";

interface Props {
  strategies: {
    id: number;
    title: string;
  }[];
  coins: {
    list: {
      image_svg: string;
    }[];
    element: number;
  };
  commissionPercent: number;
  plan: string;
}
defineProps<Props>();
</script>

<style>
.coins-wrapper:nth-child(1) {
  left: 0 !important;
}
.coin-image:not(:last-child) {
  margin-left: -6px;
}
.coin-image:last-child {
  margin-left: -6px;
}
.coin-image:first-child {
  margin-left: 0px;
}
.coin-image svg {
  flex-shrink: 0;
  width: 100% !important;
  height: 100% !important;
}
</style>
